"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sum = exports.convert = exports.getSymbol = exports.SYMBOL_MAP = exports.getLabel = exports.LABEL_MAP = exports.getSchema = exports.Pressure = exports.UsPressure = exports.ImperialPressure = exports.Psi = exports.SiPressure = exports.Decibar = exports.Bar = exports.Pascal = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
exports.NAMESPACE = 'Unit.Pressure';
exports.Pascal = effect_1.Schema.TaggedStruct('Pascal', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.Pascal` });
exports.Bar = effect_1.Schema.TaggedStruct('Bar', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.Bar` });
exports.Decibar = effect_1.Schema.TaggedStruct('Decibar', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.Decibar` });
exports.SiPressure = effect_1.Schema.Union(exports.Pascal, exports.Bar, exports.Decibar).annotations({
    identifier: `${exports.NAMESPACE}.SiPressure`,
    description: 'A unit of pressure within the International System of Units (SI)',
    documentation: 'https://en.wikipedia.org/wiki/International_System_of_Units',
});
exports.Psi = effect_1.Schema.TaggedStruct('Psi', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.Psi` });
exports.ImperialPressure = effect_1.Schema.Union(exports.Psi).annotations({
    identifier: `${exports.NAMESPACE}.ImperialPressure`,
    description: 'A unit of pressure within the imperial system of units',
    documentation: 'https://en.wikipedia.org/wiki/Imperial_units',
});
exports.UsPressure = effect_1.Schema.Union(exports.Psi).annotations({
    identifier: `${exports.NAMESPACE}.UsPressure`,
    description: 'A unit of pressure within the United States customary system',
    documentation: 'https://en.wikipedia.org/wiki/United_States_customary_units',
});
exports.Pressure = effect_1.Schema.Union(...exports.SiPressure.members, exports.UsPressure).annotations({
    identifier: `${exports.NAMESPACE}.Pressure`,
    description: 'A unit of pressure in any system of units',
});
exports.getSchema = effect_1.Match.type().pipe(effect_1.Match.when('SI', () => exports.SiPressure), effect_1.Match.when('IMPERIAL', () => exports.ImperialPressure), effect_1.Match.when('US', () => exports.UsPressure), effect_1.Match.exhaustive);
exports.LABEL_MAP = {
    // SI
    Pascal: 'pascal',
    Bar: 'bar',
    Decibar: 'decibar',
    // Imperial & US
    Psi: 'pound per square inch',
};
/**
 * Retrieves the label corresponding to a given {@link Pressure}-tag
 */
const getLabel = (tag) => exports.LABEL_MAP[tag];
exports.getLabel = getLabel;
exports.SYMBOL_MAP = {
    // SI
    Pascal: 'Pa',
    Bar: 'bar',
    Decibar: 'dbar',
    // Imperial & US
    Psi: 'psi',
};
/**
 * Retrieves the symbol corresponding to a given {@link Pressure}-tag
 */
const getSymbol = (tag) => exports.SYMBOL_MAP[tag];
exports.getSymbol = getSymbol;
/**
 * Ratio between {@link Pascal} and other {@link Pressure} unit of measure
 */
const FACTOR_MAP = {
    Pascal: 1,
    Bar: 100_000,
    Decibar: 10_000,
    Psi: 6_894.75729,
};
/**
 * Converts any {@link Pressure} to a specific pressure measure
 */
exports.convert = effect_1.Function.dual(2, (pressure, outTag) => {
    const pascal = pressure.amount * FACTOR_MAP[pressure._tag];
    return {
        _tag: outTag,
        amount: pascal / FACTOR_MAP[outTag],
    };
});
/**
 * Sums {@link Pressure} quantities and returns the result in the unit of measure of the 0th parameter
 */
const sum = (pressure, ...args) => effect_1.Array.reduce(args, pressure, (acc, pressure) => ({
    ...acc,
    amount: acc.amount + (0, exports.convert)(pressure, acc._tag).amount,
}));
exports.sum = sum;
//# sourceMappingURL=pressure.js.map